import { render, staticRenderFns } from "./regionFixWrapper.vue?vue&type=template&id=1c7d92a9&scoped=true&"
import script from "./regionFixWrapper.vue?vue&type=script&lang=js&"
export * from "./regionFixWrapper.vue?vue&type=script&lang=js&"
import style0 from "./regionFixWrapper.vue?vue&type=style&index=0&id=1c7d92a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7d92a9",
  null
  
)

export default component.exports